import { CommonModule } from '@angular/common';
import { ExpenseDetailRoutingModule } from './expense-detail-routing.module';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ExpenseDetailRoutingModule,
  ]
})
export class ExpenseDetailModule { }
